// SubtitleFeatureBlock.js
import React from 'react';
import './SubtitleFeatureBlock.css';

const SubtitleFeatureBlock = () => {
    return (
        <div className="subtitle-block">
            <div className="subtitle-block-container">
                <div className="subtitle-block-content">
                    <div className="subtitle-block-media">
                        <img
                            src="/image/subtitle.png"
                            alt="Fonction de sous-titres"
                            className="subtitle-block-image"
                        />

                    </div>

                    <div className="subtitle-block-info">
                        <div className="subtitle-block-badge">
                            <i className="fas fa-closed-captioning"></i>
                            Sous-titres intelligents
                        </div>
                        <h3 className="subtitle-block-title">Rendez vos vidéos accessibles à une audience internationale</h3>
                        <p className="subtitle-block-description">
                            Génération automatique de sous-titres en 30+ langues avec une synchronisation parfaite. Optimisez votre contenu pour les réseaux sociaux et augmentez votre portée mondiale.
                        </p>

                        <div className="subtitle-block-stats">
                            <div className="subtitle-block-stat">
                                <span className="subtitle-block-number">30+</span>
                                <span className="subtitle-block-label">Langues disponibles</span>
                            </div>
                            <div className="subtitle-block-stat">
                                <span className="subtitle-block-number">99%</span>
                                <span className="subtitle-block-label">Précision synchronisation</span>
                            </div>
                            <div className="subtitle-block-stat">
                                <span className="subtitle-block-number">2x</span>
                                <span className="subtitle-block-label">Engagement utilisateur</span>
                            </div>
                        </div>

                        <button className="subtitle-block-button">
                            Essayer maintenant
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubtitleFeatureBlock;